import React from "react";
import { MetricComponentProps } from "../../types/metrics";
import MetricItem from "./MetricItem";
import { formatTermLength } from "./metricHelpers";

export default function TermLengthPrimaryMetric({ sim }: MetricComponentProps) {
  return <MetricItem value={formatTermLength(sim)} tooltip="Mortgage Term" />;
}
